
import moment from 'moment';
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { URL_LIST_ALL } from '../../configs/api';
import Axios from "axios";
import { checkRole } from '../../model';
import parse from 'html-react-parser'


export default function ModalDetail(props) {
    const { showFullPhones, setShowFullPhones, item, user,button_title } = props
    const [showModal, setShowModal] = useState(false)
    const allowTakeCare = checkRole(user, 'khach-hang-cua-toi', 'takecare');
    const role_viewsource = checkRole(user, 'khach-hang-cua-toi', 'viewsource');
    const viewCampaign = checkRole(user, 'campaign', '');

    const getPhoneDisplay = (item) => {
        if (item) {
            const phone = item.contact || "";
            const digits = phone.replace(/\D/g, "");
            if (showFullPhones == item.id) return digits;
            if (digits.length < 7) return digits;
            return `${digits.slice(0, 3)}****${digits.slice(-3)}`;
        } else {
            return null
        }
    };

    const startTakeCare = (item) => {
        if (item.position != 3 && item.position < 9 && allowTakeCare) {
            let datasave = { user_id: user.data.id, customer_id: item.customer_id, action: "note", mainnote: "Bắt đầu chăm sóc khách" }
            Axios.post(URL_LIST_ALL + 'sale_customer', datasave, user.config).then(res => { }).catch(err => console.log(err));
        }
    }

    return <>
        <button
            type="button"
            className="btn btn-sm btn-primary w-100"
            onClick={() => {
                setShowModal(!showModal);
            }}
        >
            {button_title ? button_title : ''} <i className="far fa-eye"></i>
        </button>
        <Modal
            className="modal-customer-detail"
            show={showModal}
            onHide={() => setShowModal(false)}
            animation={true}
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Chi tiết
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {item ? <>
                    <p className="mb-1">Họ tên: <strong className="font-16">{item?.fullname}</strong></p>
                    <p className="mb-1">SĐT:  <button type="button" className="btn btn-sm btn-info" disabled={item.status == 1 ? false : true} onClick={() => {
                        if (showFullPhones !== item.id) startTakeCare(item);
                        setShowFullPhones(showFullPhones === item.id ? null : item.id);
                    }}>
                        <span>{getPhoneDisplay(item)}</span>
                    </button>
                        <button type="button" className="btn btn-sm btn-success ml-2" disabled={item.status == 1 ? false : true} onClick={() => {
                            startTakeCare(item)
                            window.location.href = `tel:${item.contact}`
                        }}>
                            <i className="fas fa-phone-volume mr-1"></i> Gọi
                        </button>
                    </p>
                    {role_viewsource && item.source &&
                        <p className="mb-1">
                            Nguồn: <strong>{item.source}</strong>
                        </p>
                    }
                    {item.tags &&  item.tags.title &&
                        <div className="w-100">
                            <p className="mb-1 mt-2">
                                Thẻ: <strong>{item.tags.title}</strong>
                            </p>
                        </div>
                    }
                    {viewCampaign && item.campaign &&
                        <div className='w-100'>
                            <div className='row'>
                                <div className='col-4'>
                                    Thuộc chiến dịch:
                                </div>
                                <div className='col-6'>
                                    <a target='_blank' href={"/edit-campaign/" + item.campaign.id} className='mb-0'><strong>{item.campaign.title}</strong> <br /></a>
                                </div>
                            </div>
                        </div>
                    }

                    <p className="mb-1 mt-2">Lịch sử chăm sóc:</p>
                    {item?.list_note && item.list_note.length > 0 ? (
                        item.list_note.map((note) => (
                            <div key={note.id} className="border rounded p-1 pl-2 pr-2 mb-2">
                                <strong>{note.salemail}</strong>: {parse(note.mainnote)}
                                <div className="show-time">
                                    <span className="far fa-clock"></span> {moment(note.datecreate).format("HH:mm DD/MM/YYYY")}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-muted">Chưa có ghi chú nào</p>
                    )}
                </>
                    : ""}
            </Modal.Body>
        </Modal>
    </>
}